import { render } from "./TodayBooking.vue?vue&type=template&id=3f681e00"
import script from "./TodayBooking.vue?vue&type=script&lang=js"
export * from "./TodayBooking.vue?vue&type=script&lang=js"

import "./TodayBooking.vue?vue&type=style&index=0&id=3f681e00&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__